import { render, staticRenderFns } from "./DemoForm.vue?vue&type=template&id=230427fb&scoped=true"
import script from "./DemoForm.vue?vue&type=script&lang=js"
export * from "./DemoForm.vue?vue&type=script&lang=js"
import style0 from "./DemoForm.vue?vue&type=style&index=0&id=230427fb&prod&scoped=true&lang=css"
import style1 from "./DemoForm.vue?vue&type=style&index=1&id=230427fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230427fb",
  null
  
)

export default component.exports